// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as ClientOptions, TDataShape } from '@hey-api/client-fetch';
import { client as _heyApiClient } from '../client';
import type {
  AppsAdminCreateData,
  AppsAdminCreateError,
  AppsAdminCreateResponse,
  AppsAdminGetData,
  AppsAdminGetError,
  AppsAdminGetResponse,
  AppsAdminListData,
  AppsAdminListError,
  AppsAdminListResponse,
  AppsAdminResetTokenData,
  AppsAdminResetTokenError,
  AppsAdminSetTokenSecretData,
  AppsAdminSetTokenSecretError,
  AppsCreateData,
  AppsCreateError,
  AppsCreateResponse,
  AppsDeleteData,
  AppsDeleteError,
  AppsGetData,
  AppsGetError,
  AppsGetResponse,
  AppsListData,
  AppsListError,
  AppsListResponse,
  AppsResetTokenData,
  AppsResetTokenError,
  AppsResetTokenResponse,
  AppsUpdateData,
  AppsUpdateError,
  AppsUpdateResponse,
  ConfigsGetConfData,
  ConfigsGetConfError,
  ConfigsGetConfResponse,
  ConfigsGetVersionData,
  ConfigsGetVersionError,
  ConfigsGetVersionResponse,
  ConfigsListErrorsData,
  ConfigsListErrorsError,
  ConfigsListErrorsResponse,
  ConfigsSetConfData,
  ConfigsSetConfError,
  EntryPassAdminCreateData,
  EntryPassAdminCreateError,
  EntryPassAdminCreateResponse,
  EntryPassAdminDeleteData,
  EntryPassAdminDeleteError,
  EntryPassAdminListData,
  EntryPassAdminListError,
  EntryPassAdminListResponse,
  EntryPassAdminUpdateData,
  EntryPassAdminUpdateError,
  EntryPassAdminUpdateResponse,
  EntryPassLoginData,
  EntryPassLoginError,
  EntryPassLoginResponse,
  EntryPassSendAuthCodeData,
  EntryPassSendAuthCodeError,
  EntryPassSendAuthCodeResponse,
  ImpactGetImpactImRefForConversionData,
  ImpactGetImpactImRefForConversionError,
  ImpactGetImpactImRefForConversionResponse,
  ImpactTrackImpactData,
  ImpactTrackImpactError,
  MedalsAdminAwardMedalData,
  MedalsAdminAwardMedalError,
  MedalsAdminAwardMedalResponse,
  MedalsAdminBatchAwardMedalData,
  MedalsAdminBatchAwardMedalError,
  MedalsAdminBatchAwardMedalResponse,
  MedalsAdminDeleteMedalData,
  MedalsAdminDeleteMedalError,
  MedalsAdminListUserMedalsData,
  MedalsAdminListUserMedalsError,
  MedalsAdminListUserMedalsResponse,
  TagsAdminBatchAddUsersToTagData,
  TagsAdminBatchAddUsersToTagError,
  TagsAdminBatchAddUsersToTagResponse,
  TagsAdminBatchRemoveUsersFromTagData,
  TagsAdminBatchRemoveUsersFromTagError,
  TagsAdminBatchRemoveUsersFromTagResponse,
  TagsAdminCreateData,
  TagsAdminCreateError,
  TagsAdminCreateResponse,
  TagsAdminDeleteData,
  TagsAdminDeleteError,
  TagsAdminGetData,
  TagsAdminGetError,
  TagsAdminGetResponse,
  TagsAdminListData,
  TagsAdminListError,
  TagsAdminListResponse,
  TagsAdminListUsersData,
  TagsAdminListUsersError,
  TagsAdminListUsersResponse,
  TagsAdminUpdateData,
  TagsAdminUpdateError,
  TagsAdminUpdateResponse,
  TracksAdminSendData,
  TracksAdminSendError,
  TracksSendData,
  TracksSendError,
  TracksUpdateData,
  TracksUpdateError,
  UsersAddInviterAwardData,
  UsersAddInviterAwardError,
  UsersAdminAddMedalData,
  UsersAdminAddMedalError,
  UsersAdminAddPlanPeriodData,
  UsersAdminAddPlanPeriodError,
  UsersAdminAddPlanPeriodResponse,
  UsersAdminAddPuppetUserData,
  UsersAdminAddPuppetUserError,
  UsersAdminAddPuppetUserResponse,
  UsersAdminAddTagData,
  UsersAdminAddTagError,
  UsersAdminAddTagResponse,
  UsersAdminAssumeUserData,
  UsersAdminAssumeUserError,
  UsersAdminAssumeUserResponse,
  UsersAdminBatchCreateData,
  UsersAdminBatchCreateError,
  UsersAdminBatchCreateResponse,
  UsersAdminBatchGetPlanPeriodsData,
  UsersAdminBatchGetPlanPeriodsError,
  UsersAdminBatchGetPlanPeriodsResponse,
  UsersAdminBatchGetPuppetUsersData,
  UsersAdminBatchGetPuppetUsersError,
  UsersAdminBatchGetPuppetUsersResponse,
  UsersAdminBatchGetUserForAuditData,
  UsersAdminBatchGetUserForAuditError,
  UsersAdminBatchGetUserForAuditResponse,
  UsersAdminCreateData,
  UsersAdminCreateError,
  UsersAdminCreateResponse,
  UsersAdminCreateUserNotificationData,
  UsersAdminCreateUserNotificationError,
  UsersAdminDeleteData,
  UsersAdminDeleteError,
  UsersAdminDeletePuppetUserData,
  UsersAdminDeletePuppetUserError,
  UsersAdminDeleteTagData,
  UsersAdminDeleteTagError,
  UsersAdminDeleteTagResponse,
  UsersAdminEditPuppetUserData,
  UsersAdminEditPuppetUserError,
  UsersAdminEditPuppetUserResponse,
  UsersAdminGetData,
  UsersAdminGetError,
  UsersAdminGetRandomPuppetUsersData,
  UsersAdminGetRandomPuppetUsersError,
  UsersAdminGetRandomPuppetUsersResponse,
  UsersAdminGetResponse,
  UsersAdminListData,
  UsersAdminListError,
  UsersAdminListPuppetUsersData,
  UsersAdminListPuppetUsersError,
  UsersAdminListPuppetUsersResponse,
  UsersAdminListResponse,
  UsersAdminSetPasswordData,
  UsersAdminSetPasswordError,
  UsersAdminSetRoleData,
  UsersAdminSetRoleError,
  UsersAdminUpdateAuditResultData,
  UsersAdminUpdateAuditResultError,
  UsersAdminUpdateData,
  UsersAdminUpdateError,
  UsersAdminUpdateResponse,
  UsersAdminValidateUserIdentifierData,
  UsersAdminValidateUserIdentifierError,
  UsersAdminValidateUserIdentifierResponse,
  UsersAppleLoginCbData,
  UsersAppleLoginCbError,
  UsersAwardMedalData,
  UsersAwardMedalError,
  UsersAwardMedalResponse,
  UsersCheckMyTeamInviteCodeData,
  UsersCheckMyTeamInviteCodeError,
  UsersCheckMyTeamInviteCodeResponse,
  UsersDeleteData,
  UsersDeleteError,
  UsersDeleteMedalData,
  UsersDeleteMedalError,
  UsersGetByInviterIdData,
  UsersGetByInviterIdError,
  UsersGetByInviterIdResponse,
  UsersGetInvitCodeTypeData,
  UsersGetInvitCodeTypeError,
  UsersGetInvitCodeTypeResponse,
  UsersGetInvitedInfoData,
  UsersGetInvitedInfoError,
  UsersGetInvitedInfoResponse,
  UsersGetInviterIdByCodeTypeData,
  UsersGetInviterIdByCodeTypeError,
  UsersGetInviterIdByCodeTypeResponse,
  UsersGetInviterIdData,
  UsersGetInviterIdError,
  UsersGetInviterIdResponse,
  UsersGetMe2Data,
  UsersGetMe2Error,
  UsersGetMe2Response,
  UsersGetMeData,
  UsersGetMeError,
  UsersGetMeNotificationData,
  UsersGetMeNotificationError,
  UsersGetMeNotificationResponse,
  UsersGetMeResponse,
  UsersGetMyTeamInviteLinkData,
  UsersGetMyTeamInviteLinkError,
  UsersGetMyTeamInviteLinkResponse,
  UsersGetUserEveryDayCreditData,
  UsersGetUserEveryDayCreditError,
  UsersGetUserEveryDayCreditResponse,
  UsersGetUserMedalsData,
  UsersGetUserMedalsError,
  UsersGetUserMedalsResponse,
  UsersGetUserTrialExpirationData,
  UsersGetUserTrialExpirationError,
  UsersGetUserTrialExpirationResponse,
  UsersGoogleLoginCbData,
  UsersGoogleLoginCbError,
  UsersJoinMyTeamByInviteCodeData,
  UsersJoinMyTeamByInviteCodeError,
  UsersJoinMyTeamByInviteCodeResponse,
  UsersListMyTeamMembersData,
  UsersListMyTeamMembersError,
  UsersListMyTeamMembersResponse,
  UsersListSpacesData,
  UsersListSpacesError,
  UsersListSpacesResponse,
  UsersLoginData,
  UsersLoginError,
  UsersLoginResponse,
  UsersLoginWithThirdPartyData,
  UsersLoginWithThirdPartyError,
  UsersLoginWithThirdPartyResponse,
  UsersLogoutData,
  UsersLogoutError,
  UsersMuteMeNotificationData,
  UsersMuteMeNotificationError,
  UsersMuteMePeriodNotificationData,
  UsersMuteMePeriodNotificationError,
  UsersQueryRegionData,
  UsersQueryRegionError,
  UsersQueryRegionResponse,
  UsersRemoveMyTeamMemberData,
  UsersRemoveMyTeamMemberError,
  UsersReviewMyTeamMemberData,
  UsersReviewMyTeamMemberError,
  UsersSendAuthCodeData,
  UsersSendAuthCodeError,
  UsersSendAuthCodeResponse,
  UsersSetShareAlertData,
  UsersSetShareAlertError,
  UsersSetShareAlertResponse,
  UsersSubmitQuestionnaireData,
  UsersSubmitQuestionnaireError,
  UsersSubmitQuestionnaireResponse,
  UsersSubscribeEmailData,
  UsersSubscribeEmailError,
  UsersSwitchSelfData,
  UsersSwitchSelfError,
  UsersSwitchSelfResponse,
  UsersSwitchSpaceData,
  UsersSwitchSpaceError,
  UsersSwitchSpaceResponse,
  UsersThirdPartyLoginData,
  UsersThirdPartyLoginError,
  UsersThirdPartyLoginResponse,
  UsersUpdateMyTeamInviteLinkData,
  UsersUpdateMyTeamInviteLinkError,
  UsersUpdateMyTeamInviteLinkResponse,
  UsersUpdateMyTeamNameData,
  UsersUpdateMyTeamNameError,
  UsersUpdateProfileData,
  UsersUpdateProfileError,
  UsersValidateInviteCodeData,
  UsersValidateInviteCodeError,
  UsersValidateInviteCodeResponse,
  UsersVerifyCaptchaGateData,
  UsersVerifyCaptchaGateError,
  UsersVerifyCaptchaGateResponse,
  UsersWechatMiniProgramLoginData,
  UsersWechatMiniProgramLoginError,
  UsersWechatMiniProgramLoginResponse,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const appsAdminList = <ThrowOnError extends boolean = false>(
  options?: Options<AppsAdminListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<AppsAdminListResponse, AppsAdminListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/apps',
    ...options,
  });
};

export const appsAdminCreate = <ThrowOnError extends boolean = false>(
  options: Options<AppsAdminCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<AppsAdminCreateResponse, AppsAdminCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/apps',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const appsAdminResetToken = <ThrowOnError extends boolean = false>(
  options: Options<AppsAdminResetTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, AppsAdminResetTokenError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/apps/reset_token',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const appsAdminSetTokenSecret = <ThrowOnError extends boolean = false>(
  options: Options<AppsAdminSetTokenSecretData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, AppsAdminSetTokenSecretError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/apps/set_token_secret',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const appsAdminGet = <ThrowOnError extends boolean = false>(
  options: Options<AppsAdminGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<AppsAdminGetResponse, AppsAdminGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/apps/{id}',
    ...options,
  });
};

/**
 * List 列表查询（按批次、subject_code、id_type、identity 过滤；分页）
 */
export const entryPassAdminList = <ThrowOnError extends boolean = false>(
  options?: Options<EntryPassAdminListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<EntryPassAdminListResponse, EntryPassAdminListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/entry-passes',
    ...options,
  });
};

/**
 * Create 按 (batch_code, subject_code) 录入一条白名单；唯一键冲突直接返回 AlreadyExists。
 */
export const entryPassAdminCreate = <ThrowOnError extends boolean = false>(
  options: Options<EntryPassAdminCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<EntryPassAdminCreateResponse, EntryPassAdminCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/entry-passes',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * Delete 按 id 删除一条白名单
 */
export const entryPassAdminDelete = <ThrowOnError extends boolean = false>(
  options: Options<EntryPassAdminDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, EntryPassAdminDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/entry-passes/{id}',
    ...options,
  });
};

/**
 * Update 按 id 更新指定白名单记录；通过 FieldMask 控制要刷新的字段。
 * 只允许更新 user_id=0（即未被首次登录绑定）的行，已绑定行返回 AlreadyExists。
 */
export const entryPassAdminUpdate = <ThrowOnError extends boolean = false>(
  options: Options<EntryPassAdminUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<EntryPassAdminUpdateResponse, EntryPassAdminUpdateError, ThrowOnError>(
    {
      security: [
        {
          scheme: 'bearer',
          type: 'http',
        },
      ],
      url: '/iam/admin/v1/entry-passes/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    },
  );
};

/**
 * 获取Tag列表
 */
export const tagsAdminList = <ThrowOnError extends boolean = false>(
  options?: Options<TagsAdminListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<TagsAdminListResponse, TagsAdminListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/tags',
    ...options,
  });
};

/**
 * 创建Tag
 */
export const tagsAdminCreate = <ThrowOnError extends boolean = false>(
  options: Options<TagsAdminCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<TagsAdminCreateResponse, TagsAdminCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/tags',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 删除Tag（通过唯一名称）
 */
export const tagsAdminDelete = <ThrowOnError extends boolean = false>(
  options: Options<TagsAdminDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, TagsAdminDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/tags/{name}',
    ...options,
  });
};

/**
 * 获取单个Tag（通过唯一名称）
 */
export const tagsAdminGet = <ThrowOnError extends boolean = false>(
  options: Options<TagsAdminGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<TagsAdminGetResponse, TagsAdminGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/tags/{name}',
    ...options,
  });
};

/**
 * 更新Tag
 */
export const tagsAdminUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TagsAdminUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<TagsAdminUpdateResponse, TagsAdminUpdateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/tags/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取Tag下的用户明细
 */
export const tagsAdminListUsers = <ThrowOnError extends boolean = false>(
  options: Options<TagsAdminListUsersData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<TagsAdminListUsersResponse, TagsAdminListUsersError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/tags/{tag_name}/users',
    ...options,
  });
};

/**
 * 批量给用户添加Tag
 */
export const tagsAdminBatchAddUsersToTag = <ThrowOnError extends boolean = false>(
  options: Options<TagsAdminBatchAddUsersToTagData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    TagsAdminBatchAddUsersToTagResponse,
    TagsAdminBatchAddUsersToTagError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/tags/{tag_name}/users/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 批量从用户中移除Tag
 */
export const tagsAdminBatchRemoveUsersFromTag = <ThrowOnError extends boolean = false>(
  options: Options<TagsAdminBatchRemoveUsersFromTagData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    TagsAdminBatchRemoveUsersFromTagResponse,
    TagsAdminBatchRemoveUsersFromTagError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/tags/{tag_name}/users/batch-remove',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const tracksAdminSend = <ThrowOnError extends boolean = false>(
  options: Options<TracksAdminSendData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, TracksAdminSendError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/tracks/send',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersAdminList = <ThrowOnError extends boolean = false>(
  options?: Options<UsersAdminListData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<UsersAdminListResponse, UsersAdminListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users',
    ...options,
  });
};

export const usersAdminCreate = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<UsersAdminCreateResponse, UsersAdminCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersAdminBatchGetUserForAudit = <ThrowOnError extends boolean = false>(
  options?: Options<UsersAdminBatchGetUserForAuditData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersAdminBatchGetUserForAuditResponse,
    UsersAdminBatchGetUserForAuditError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/audit/batch_get',
    ...options,
  });
};

export const usersAdminUpdateAuditResult = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminUpdateAuditResultData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, UsersAdminUpdateAuditResultError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/audit/result',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersAdminBatchCreate = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminBatchCreateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UsersAdminBatchCreateResponse,
    UsersAdminBatchCreateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 颁发用户勋章
 */
export const medalsAdminAwardMedal = <ThrowOnError extends boolean = false>(
  options: Options<MedalsAdminAwardMedalData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MedalsAdminAwardMedalResponse,
    MedalsAdminAwardMedalError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/medals',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 批量颁发用户勋章
 */
export const medalsAdminBatchAwardMedal = <ThrowOnError extends boolean = false>(
  options: Options<MedalsAdminBatchAwardMedalData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    MedalsAdminBatchAwardMedalResponse,
    MedalsAdminBatchAwardMedalError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/medals/batch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 删除用户勋章
 */
export const medalsAdminDeleteMedal = <ThrowOnError extends boolean = false>(
  options: Options<MedalsAdminDeleteMedalData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, MedalsAdminDeleteMedalError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/medals/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 根据特定类型查询用户勋章记录，按时间排序
 */
export const medalsAdminListUserMedals = <ThrowOnError extends boolean = false>(
  options?: Options<MedalsAdminListUserMedalsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    MedalsAdminListUserMedalsResponse,
    MedalsAdminListUserMedalsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/medals/list',
    ...options,
  });
};

export const usersAdminBatchGetPlanPeriods = <ThrowOnError extends boolean = false>(
  options?: Options<UsersAdminBatchGetPlanPeriodsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersAdminBatchGetPlanPeriodsResponse,
    UsersAdminBatchGetPlanPeriodsError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/plan-periods',
    ...options,
  });
};

/**
 * 校验邮箱/手机号/discord id是否存在对应用户
 */
export const usersAdminValidateUserIdentifier = <ThrowOnError extends boolean = false>(
  options?: Options<UsersAdminValidateUserIdentifierData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersAdminValidateUserIdentifierResponse,
    UsersAdminValidateUserIdentifierError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/validate',
    ...options,
  });
};

export const usersAdminDelete = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminDeleteData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, UsersAdminDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/{id}',
    ...options,
  });
};

export const usersAdminGet = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminGetData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<UsersAdminGetResponse, UsersAdminGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/{id}',
    ...options,
  });
};

export const usersAdminAssumeUser = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminAssumeUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<UsersAdminAssumeUserResponse, UsersAdminAssumeUserError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/{id}/assume',
    ...options,
  });
};

export const usersAdminAddMedal = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminAddMedalData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, UsersAdminAddMedalError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/{id}/medal',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersAdminCreateUserNotification = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminCreateUserNotificationData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, UsersAdminCreateUserNotificationError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/{id}/notification',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersAdminSetPassword = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminSetPasswordData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, UsersAdminSetPasswordError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/{id}/password',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * [PRIVILEGED] change role for a user
 */
export const usersAdminSetRole = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminSetRoleData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, UsersAdminSetRoleError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/{id}/role',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersAdminDeleteTag = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminDeleteTagData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<UsersAdminDeleteTagResponse, UsersAdminDeleteTagError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/{id}/tag',
    ...options,
  });
};

export const usersAdminAddTag = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminAddTagData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<UsersAdminAddTagResponse, UsersAdminAddTagError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/{id}/tag',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersAdminUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<UsersAdminUpdateResponse, UsersAdminUpdateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/{user.id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersAdminAddPlanPeriod = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminAddPlanPeriodData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UsersAdminAddPlanPeriodResponse,
    UsersAdminAddPlanPeriodError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/admin/v1/users/{user_id}/plan-period',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const appsList = <ThrowOnError extends boolean = false>(options?: Options<AppsListData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<AppsListResponse, AppsListError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/apps',
    ...options,
  });
};

export const appsCreate = <ThrowOnError extends boolean = false>(options: Options<AppsCreateData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<AppsCreateResponse, AppsCreateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/apps',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const appsResetToken = <ThrowOnError extends boolean = false>(
  options: Options<AppsResetTokenData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<AppsResetTokenResponse, AppsResetTokenError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/apps/reset_token',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * update app name and status
 */
export const appsUpdate = <ThrowOnError extends boolean = false>(options: Options<AppsUpdateData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).patch<AppsUpdateResponse, AppsUpdateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/apps/{app.id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const appsDelete = <ThrowOnError extends boolean = false>(options: Options<AppsDeleteData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).delete<unknown, AppsDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/apps/{id}',
    ...options,
  });
};

export const appsGet = <ThrowOnError extends boolean = false>(options: Options<AppsGetData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<AppsGetResponse, AppsGetError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/apps/{id}',
    ...options,
  });
};

/**
 * get a configuration item
 */
export const configsGetConf = <ThrowOnError extends boolean = false>(
  options: Options<ConfigsGetConfData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<ConfigsGetConfResponse, ConfigsGetConfError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/conf/{name}',
    ...options,
  });
};

/**
 * set/change a configuration item
 */
export const configsSetConf = <ThrowOnError extends boolean = false>(
  options: Options<ConfigsSetConfData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, ConfigsSetConfError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/conf/{name}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const entryPassLogin = <ThrowOnError extends boolean = false>(
  options: Options<EntryPassLoginData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<EntryPassLoginResponse, EntryPassLoginError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/entry-pass/login',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * SendAuthCode 校验白名单 + 身份证后六位通过后，才向 receiver(手机号或邮箱) 发送验证码。
 */
export const entryPassSendAuthCode = <ThrowOnError extends boolean = false>(
  options: Options<EntryPassSendAuthCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    EntryPassSendAuthCodeResponse,
    EntryPassSendAuthCodeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/entry-pass/send-code',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * List Errors info
 */
export const configsListErrors = <ThrowOnError extends boolean = false>(
  options?: Options<ConfigsListErrorsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ConfigsListErrorsResponse, ConfigsListErrorsError, ThrowOnError>({
    url: '/iam/v1/errors',
    ...options,
  });
};

export const impactGetImpactImRefForConversion = <ThrowOnError extends boolean = false>(
  options?: Options<ImpactGetImpactImRefForConversionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    ImpactGetImpactImRefForConversionResponse,
    ImpactGetImpactImRefForConversionError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/impact/get_im_ref',
    ...options,
  });
};

export const impactTrackImpact = <ThrowOnError extends boolean = false>(
  options: Options<ImpactTrackImpactData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, ImpactTrackImpactError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/impact/track',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const tracksSend = <ThrowOnError extends boolean = false>(options: Options<TracksSendData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<unknown, TracksSendError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/tracks/send',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const tracksUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TracksUpdateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, TracksUpdateError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/tracks/update',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersAddInviterAward = <ThrowOnError extends boolean = false>(
  options: Options<UsersAddInviterAwardData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, UsersAddInviterAwardError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/add-inviter-award',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersVerifyCaptchaGate = <ThrowOnError extends boolean = false>(
  options: Options<UsersVerifyCaptchaGateData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UsersVerifyCaptchaGateResponse,
    UsersVerifyCaptchaGateError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/captcha-gate',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersGetUserEveryDayCredit = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetUserEveryDayCreditData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersGetUserEveryDayCreditResponse,
    UsersGetUserEveryDayCreditError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/every-day-credit',
    ...options,
  });
};

export const usersGetByInviterId = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetByInviterIdData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<UsersGetByInviterIdResponse, UsersGetByInviterIdError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/get-by-inviter-id',
    ...options,
  });
};

export const usersGetInvitCodeType = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetInvitCodeTypeData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersGetInvitCodeTypeResponse,
    UsersGetInvitCodeTypeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/get-invit-code-type',
    ...options,
  });
};

export const usersGetInvitedInfo = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetInvitedInfoData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<UsersGetInvitedInfoResponse, UsersGetInvitedInfoError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/get-invited-info',
    ...options,
  });
};

export const usersGetInviterId = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetInviterIdData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<UsersGetInviterIdResponse, UsersGetInviterIdError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/get-inviter-id',
    ...options,
  });
};

export const usersGetInviterIdByCodeType = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetInviterIdByCodeTypeData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersGetInviterIdByCodeTypeResponse,
    UsersGetInviterIdByCodeTypeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/get-inviter-id-by-code-type',
    ...options,
  });
};

export const usersLogin = <ThrowOnError extends boolean = false>(options: Options<UsersLoginData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<UsersLoginResponse, UsersLoginError, ThrowOnError>({
    url: '/iam/v1/users/login',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersAppleLoginCb = <ThrowOnError extends boolean = false>(
  options: Options<UsersAppleLoginCbData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, UsersAppleLoginCbError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/login/apple-login-cb',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersGoogleLoginCb = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGoogleLoginCbData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<unknown, UsersGoogleLoginCbError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/login/google-login-cb',
    ...options,
  });
};

/**
 * third party app login
 */
export const usersThirdPartyLogin = <ThrowOnError extends boolean = false>(
  options?: Options<UsersThirdPartyLoginData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<UsersThirdPartyLoginResponse, UsersThirdPartyLoginError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/login/third-party',
    ...options,
  });
};

export const usersLoginWithThirdParty = <ThrowOnError extends boolean = false>(
  options: Options<UsersLoginWithThirdPartyData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UsersLoginWithThirdPartyResponse,
    UsersLoginWithThirdPartyError,
    ThrowOnError
  >({
    url: '/iam/v1/users/login/third-party',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersWechatMiniProgramLogin = <ThrowOnError extends boolean = false>(
  options: Options<UsersWechatMiniProgramLoginData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UsersWechatMiniProgramLoginResponse,
    UsersWechatMiniProgramLoginError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/login/wechat-mini-program',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * clear HTTP cookies
 */
export const usersLogout = <ThrowOnError extends boolean = false>(options: Options<UsersLogoutData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).post<unknown, UsersLogoutError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/logout',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * delete myself
 */
export const usersDelete = <ThrowOnError extends boolean = false>(options?: Options<UsersDeleteData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).delete<unknown, UsersDeleteError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/me',
    ...options,
  });
};

/**
 * retrieve my info
 */
export const usersGetMe = <ThrowOnError extends boolean = false>(options?: Options<UsersGetMeData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<UsersGetMeResponse, UsersGetMeError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/me',
    ...options,
  });
};

/**
 * retrieve my info; also returns the real user in an assume context
 */
export const usersGetMe2 = <ThrowOnError extends boolean = false>(options?: Options<UsersGetMe2Data, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<UsersGetMe2Response, UsersGetMe2Error, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/me2',
    ...options,
  });
};

/**
 * 获取用户勋章
 */
export const usersGetUserMedals = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetUserMedalsData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<UsersGetUserMedalsResponse, UsersGetUserMedalsError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/medals',
    ...options,
  });
};

/**
 * 颁发用户勋章
 */
export const usersAwardMedal = <ThrowOnError extends boolean = false>(
  options: Options<UsersAwardMedalData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<UsersAwardMedalResponse, UsersAwardMedalError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/medals',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 删除用户勋章
 */
export const usersDeleteMedal = <ThrowOnError extends boolean = false>(
  options: Options<UsersDeleteMedalData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, UsersDeleteMedalError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/medals/delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersMuteMeNotification = <ThrowOnError extends boolean = false>(
  options?: Options<UsersMuteMeNotificationData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).delete<unknown, UsersMuteMeNotificationError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/notification',
    ...options,
  });
};

export const usersGetMeNotification = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetMeNotificationData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersGetMeNotificationResponse,
    UsersGetMeNotificationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/notification',
    ...options,
  });
};

export const usersMuteMePeriodNotification = <ThrowOnError extends boolean = false>(
  options?: Options<UsersMuteMePeriodNotificationData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).delete<unknown, UsersMuteMePeriodNotificationError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/notification/period',
    ...options,
  });
};

export const usersUpdateProfile = <ThrowOnError extends boolean = false>(
  options: Options<UsersUpdateProfileData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).patch<unknown, UsersUpdateProfileError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/profile',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 查看puppet用户列表
 */
export const usersAdminListPuppetUsers = <ThrowOnError extends boolean = false>(
  options?: Options<UsersAdminListPuppetUsersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersAdminListPuppetUsersResponse,
    UsersAdminListPuppetUsersError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/puppet',
    ...options,
  });
};

/**
 * 新增puppet用户
 */
export const usersAdminAddPuppetUser = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminAddPuppetUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UsersAdminAddPuppetUserResponse,
    UsersAdminAddPuppetUserError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/puppet',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 批量获取puppet用户
 */
export const usersAdminBatchGetPuppetUsers = <ThrowOnError extends boolean = false>(
  options?: Options<UsersAdminBatchGetPuppetUsersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersAdminBatchGetPuppetUsersResponse,
    UsersAdminBatchGetPuppetUsersError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/puppet/batch',
    ...options,
  });
};

/**
 * 随机获取指定数量的puppet用户
 */
export const usersAdminGetRandomPuppetUsers = <ThrowOnError extends boolean = false>(
  options?: Options<UsersAdminGetRandomPuppetUsersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersAdminGetRandomPuppetUsersResponse,
    UsersAdminGetRandomPuppetUsersError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/puppet/random',
    ...options,
  });
};

/**
 * 删除puppet用户
 */
export const usersAdminDeletePuppetUser = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminDeletePuppetUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, UsersAdminDeletePuppetUserError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/puppet/{user_id}',
    ...options,
  });
};

/**
 * 编辑puppet用户
 */
export const usersAdminEditPuppetUser = <ThrowOnError extends boolean = false>(
  options: Options<UsersAdminEditPuppetUserData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UsersAdminEditPuppetUserResponse,
    UsersAdminEditPuppetUserError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/puppet/{user_id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersQueryRegion = <ThrowOnError extends boolean = false>(
  options?: Options<UsersQueryRegionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<UsersQueryRegionResponse, UsersQueryRegionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/query-region',
    ...options,
  });
};

export const usersSubmitQuestionnaire = <ThrowOnError extends boolean = false>(
  options: Options<UsersSubmitQuestionnaireData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UsersSubmitQuestionnaireResponse,
    UsersSubmitQuestionnaireError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/questionnaire',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersSendAuthCode = <ThrowOnError extends boolean = false>(
  options: Options<UsersSendAuthCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<UsersSendAuthCodeResponse, UsersSendAuthCodeError, ThrowOnError>({
    url: '/iam/v1/users/send-auth-code',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersSetShareAlert = <ThrowOnError extends boolean = false>(
  options: Options<UsersSetShareAlertData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<UsersSetShareAlertResponse, UsersSetShareAlertError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/set-shart-alert',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * list team/space memberships for current primary user
 */
export const usersListSpaces = <ThrowOnError extends boolean = false>(
  options?: Options<UsersListSpacesData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<UsersListSpacesResponse, UsersListSpacesError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/spaces',
    ...options,
  });
};

/**
 * switch current effective user to the team member user of the space
 */
export const usersSwitchSpace = <ThrowOnError extends boolean = false>(
  options: Options<UsersSwitchSpaceData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<UsersSwitchSpaceResponse, UsersSwitchSpaceError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/spaces/switch',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 用户订阅邮件
 */
export const usersSubscribeEmail = <ThrowOnError extends boolean = false>(
  options: Options<UsersSubscribeEmailData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, UsersSubscribeEmailError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/subscribe-email',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

export const usersSwitchSelf = <ThrowOnError extends boolean = false>(
  options?: Options<UsersSwitchSelfData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).post<UsersSwitchSelfResponse, UsersSwitchSelfError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/switch-self',
    ...options,
  });
};

/**
 * get current team invite link settings (admin only)
 */
export const usersGetMyTeamInviteLink = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetMyTeamInviteLinkData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersGetMyTeamInviteLinkResponse,
    UsersGetMyTeamInviteLinkError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/team/invite-link',
    ...options,
  });
};

/**
 * update current team invite link settings (admin only)
 */
export const usersUpdateMyTeamInviteLink = <ThrowOnError extends boolean = false>(
  options: Options<UsersUpdateMyTeamInviteLinkData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<
    UsersUpdateMyTeamInviteLinkResponse,
    UsersUpdateMyTeamInviteLinkError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/team/invite-link',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * check invite status by invite code (login required)
 */
export const usersCheckMyTeamInviteCode = <ThrowOnError extends boolean = false>(
  options: Options<UsersCheckMyTeamInviteCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UsersCheckMyTeamInviteCodeResponse,
    UsersCheckMyTeamInviteCodeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/team/invite-link/check',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * apply join by invite code (login required)
 */
export const usersJoinMyTeamByInviteCode = <ThrowOnError extends boolean = false>(
  options: Options<UsersJoinMyTeamByInviteCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<
    UsersJoinMyTeamByInviteCodeResponse,
    UsersJoinMyTeamByInviteCodeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/team/invite-link/join',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * list members in current team space
 */
export const usersListMyTeamMembers = <ThrowOnError extends boolean = false>(
  options?: Options<UsersListMyTeamMembersData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersListMyTeamMembersResponse,
    UsersListMyTeamMembersError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/team/members',
    ...options,
  });
};

/**
 * review pending team member from team member list (admin only)
 */
export const usersReviewMyTeamMember = <ThrowOnError extends boolean = false>(
  options: Options<UsersReviewMyTeamMemberData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).post<unknown, UsersReviewMyTeamMemberError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/team/members/review',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * remove a member from current team space (admin only)
 */
export const usersRemoveMyTeamMember = <ThrowOnError extends boolean = false>(
  options: Options<UsersRemoveMyTeamMemberData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).delete<unknown, UsersRemoveMyTeamMemberError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/team/members/{account}',
    ...options,
  });
};

/**
 * update current team's customer_name (admin only)
 */
export const usersUpdateMyTeamName = <ThrowOnError extends boolean = false>(
  options: Options<UsersUpdateMyTeamNameData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).put<unknown, UsersUpdateMyTeamNameError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/team/update-name',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
};

/**
 * 获取用户赠送的试用套餐的有效期
 */
export const usersGetUserTrialExpiration = <ThrowOnError extends boolean = false>(
  options?: Options<UsersGetUserTrialExpirationData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<
    UsersGetUserTrialExpirationResponse,
    UsersGetUserTrialExpirationError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/trial-sub-expiration',
    ...options,
  });
};

export const usersValidateInviteCode = <ThrowOnError extends boolean = false>(
  options: Options<UsersValidateInviteCodeData, ThrowOnError>,
) => {
  return (options.client ?? _heyApiClient).get<
    UsersValidateInviteCodeResponse,
    UsersValidateInviteCodeError,
    ThrowOnError
  >({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/users/validate-invite-code/{code}',
    ...options,
  });
};

export const configsGetVersion = <ThrowOnError extends boolean = false>(
  options?: Options<ConfigsGetVersionData, ThrowOnError>,
) => {
  return (options?.client ?? _heyApiClient).get<ConfigsGetVersionResponse, ConfigsGetVersionError, ThrowOnError>({
    security: [
      {
        scheme: 'bearer',
        type: 'http',
      },
    ],
    url: '/iam/v1/version',
    ...options,
  });
};
